import library from '../../../../utils/Library'

const generateJwt3 = (jwt2, callback) => {
  const URL_GENERATE_JWT3 = library.getBaseAPIUrl('generateJwt3')
  const requestOptions = {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      appCode: 'ME',
      jwt2: jwt2
    })
  }

  try {
    fetch(URL_GENERATE_JWT3, requestOptions)
      .then(async (response) => {
        const data = await response.json()
        if (response.status !== 302) {
          // eslint-disable-next-line
              return callback({ code: true, api: data.api });
        }

        document.cookie = `syserrepar_JWT2=${data.jwt3}; path=/; domain=.errepar.com; max-age=43200; SameSite=None; Secure`
        // eslint-disable-next-line
            callback({ message: "Login exitoso", data: data.jwt3 });
        // domain=.errepar.com;
      })
      .catch(() => callback(null))
  } catch (error) {
    callback(null)
  }
}
export default generateJwt3
